import React, { useRef, useMemo } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import './index.scss';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import ChartTypeTab from '@/pages/intelligence/components/ChartsComponents/ChartTypeTab';
import JumpToTopCharts from '@intelligence/pages/TopCharts/components/StoreRankDetailsCore/components/Visualis/components/JumpToTopCharts';
import classnames from 'classnames';
import { computeRankAxisOverrides } from '@/pages/intelligence/utils/storeRankAxisUtils';

const CommonVisualis = (props: any) => {
  const {
    lineSeriesData,
    cardStatus,
    chartType,
    entityType,
    cardTitle = '',
    pageId = '',
    isHasSegmentChartIcon = false,
    segmentList = [],
    statusHeight, // 中间态调试，比如loding
    isStoreRank = false,
    // Y 轴不展示小数 label
    noDecimalsLabel,
    segmentValue,
    chartSegmentList,
    setSegmentValue,
    handleMetricChangeFun,
    isShowNoDataSegment = false,
    currentFetchSource,
  } = props;

  // console.log('CommonVisualis', props);
  const cardRef = useRef(null);

  const { formatMessage } = useIntlExtend();
  const { isLoading, isError, isNoData } = cardStatus || {};

  // const [segmentValue, setSegmentValue] = useState(
  //   segmentList?.length > 0 ? segmentList[0]?.value : '',
  // );

  const segementTitle = useMemo(() => {
    const segObj = segmentList?.find((item: any) => item.value === segmentValue);
    return formatMessage({ id: segObj.textKey });
  }, [segmentValue]);

  // useEffect(() => {
  //   const activeSegData = lineData?.filter((t: any) => {
  //     return t.metric === metricSegVal;
  //   })[0];
  //   setActiveLineData(activeSegData?.history);
  //   const countValue = Math.max(
  //     activeSegData?.avg_by_line,
  //     activeSegData?.max_by_line,
  //     activeSegData?.total_by_line,
  //   );

  //   setCountValue(tableDataFormatKMB(countValue));
  // }, [metricSegVal, lineData]);

  // const defaultSegment = useMemo(() => {
  //   return segmentList?.length > 0 ? segmentList[0].value : '';
  // }, [segmentList]);

  const handleMetricChange = (value: string): void => {
    handleMetricChangeFun?.(value);
    setSegmentValue(value);
  };

  // const lineSeriesDataCur = useMemo(() => {
  //   return lineSeriesData[segmentValue];
  // }, [lineSeriesData, segmentValue]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: segmentValue,
    topChartsType: 'detailStorerank',
    titleNow: segementTitle,
    imageType: entityType,
    yAxisFormatter: noDecimalsLabel
      ? (value: number) => {
          // 不展示小数 Y 轴 label
          return String(value).includes('.') ? '' : value;
        }
      : undefined,
  });

  const storeRankValues = useMemo(() => {
    if (!isStoreRank) return [];
    const currentSeriesList = lineSeriesData?.[segmentValue] || [];
    const values: number[] = [];
    currentSeriesList.forEach((seriesItem: any) => {
      seriesItem?.history?.forEach((historyItem: any) => {
        const value = Number(historyItem?.value);
        if (Number.isFinite(value)) {
          values.push(value);
        }
      });
    });
    return values;
  }, [isStoreRank, lineSeriesData, segmentValue]);

  const rankAxisOverrides = useMemo(() => {
    if (!isStoreRank) return null;
    return computeRankAxisOverrides(storeRankValues, 1);
  }, [isStoreRank, storeRankValues]);

  const lineOptionCur = useMemo(() => {
    if (isStoreRank && rankAxisOverrides) {
      return {
        ...lineOption,
        yAxis: {
          ...lineOption.yAxis,
          inverse: true,
          min: rankAxisOverrides.min,
          max: rankAxisOverrides.max ?? undefined,
          minInterval: 1,
          interval: rankAxisOverrides.interval ?? undefined,
        },
      };
    }
    return lineOption;
  }, [isStoreRank, lineOption, rankAxisOverrides]);

  return (
    <div className="dbi-trends-card dbi-common-visualis">
      <CardSlotV2
        className={classnames('dbi-mobileGames-card-context dbi-mobileGames-title-custom', {
          'dbi-commonVisualis-combine-ranktTrend': pageId === 'detailStorerank-combine-ranktTrend',
        })}
        title={cardTitle}
        rightDom={
          <JumpToTopCharts entityType={entityType} currentFetchSource={currentFetchSource} />
        }
        iconList={[]}
      >
        {isShowNoDataSegment ? (
          <>
            {segmentList?.length > 0 ? (
              <ChartTypeTab
                defaultValue={segmentValue}
                selectType={entityType + pageId}
                sendSegment={handleMetricChange}
                isIconMetrics={isHasSegmentChartIcon}
                chartSegmentList={chartSegmentList}
              />
            ) : null}
            {isLoading || isNoData || isError ? (
              <CardStats cardStatus={cardStatus} height={statusHeight} />
            ) : (
              <>
                <div className="card-line card-line-common" ref={cardRef}>
                  <ChartsIndex
                    chartLoading={isLoading}
                    lineOption={lineOptionCur}
                    chartType={chartType}
                    isNodata={isNoData}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {isLoading || isNoData || isError ? (
              <CardStats cardStatus={cardStatus} height={statusHeight} />
            ) : (
              <>
                {segmentList?.length > 0 ? (
                  <ChartTypeTab
                    defaultValue={segmentValue}
                    selectType={entityType + pageId}
                    sendSegment={handleMetricChange}
                    isIconMetrics={isHasSegmentChartIcon}
                    chartSegmentList={chartSegmentList}
                  />
                ) : null}

                <div className="card-line card-line-common" ref={cardRef}>
                  <ChartsIndex
                    chartLoading={isLoading}
                    lineOption={lineOptionCur}
                    chartType={chartType}
                    isNodata={isNoData}
                  />
                </div>
              </>
            )}
          </>
        )}
      </CardSlotV2>
    </div>
  );
};
export default CommonVisualis;
